var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoopowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 85,
    viewBox: "0 0 122 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2858",
    "data-name": "Group 2858",
    transform: "translate(-204 -83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BANNER_LEFT",
    "data-name": "BANNER LEFT",
    d: "M0,0H122a0,0,0,0,1,0,0V39A46,46,0,0,1,76,85H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(204 83)",
    fill: "#1a5560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-home",
    "data-name": "Icon open-home",
    d: "M8.92,0,0,6.69H2.23v8.92H6.69v-4.46h4.46v4.46h4.46V6.623l2.23.067Z",
    transform: "translate(304.345 87.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "HOO",
    transform: "translate(226 125)",
    fill: "#fff",
    fontSize: 36,
    fontFamily: "FredokaOne-Regular, Fredoka One",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HOO")), /*#__PURE__*/React.createElement("text", {
    id: "PO",
    transform: "translate(226 154)",
    fill: "#fff",
    fontSize: 36,
    fontFamily: "FredokaOne-Regular, Fredoka One",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PO")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2839",
    "data-name": "Group 2839",
    transform: "translate(113.751 106.841)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1250",
    "data-name": "Rectangle 1250",
    width: 27.05,
    height: 26.373,
    rx: 5,
    transform: "translate(162.344 22.812) rotate(-7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "W",
    transform: "translate(176.249 44.159)",
    fill: "#1a5560",
    fontSize: 25,
    fontFamily: "FredokaOne-Regular, Fredoka One",
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.488,
    y: 0
  }, "W"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoopowLogo);
export default __webpack_public_path__ + "static/media/hoopow_logo.8f0982c2.svg";
export { ForwardRef as ReactComponent };